import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_421: DocMigration = {
  maxSchemaVersion: "0.0.421",
  description: "Assign palette type to casework instances",
  apply(json: any) {
    for (const caseworkId in json.casework) {
      const casework = json.casework[caseworkId];
      casework.paletteType = "INTERIOR_PALETTE";
    }

    return json;
  },
};

export default migration_0_0_421;
